export default __webpack_public_path__ + "static/media/Left-Photo-Enterprise2x.512950fb.jpg";